export default "__VITE_ASSET__27Qx7bbE__"